<script setup>
import Spinner from 'shared/components/Spinner.vue';

defineProps({
  data: {
    type: Array,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: 'Top Caixas de Entrada',
  },
});

function getChannelIcon(channelType) {
  const iconMap = {
    'Channel::WebWidget': 'i-lucide-globe',
    'Channel::Api': 'i-lucide-webhook',
    'Channel::Whatsapp': 'i-lucide-message-circle',
    'Channel::FacebookPage': 'i-lucide-facebook',
    'Channel::Email': 'i-lucide-mail',
    'Channel::Telegram': 'i-lucide-send',
    'Channel::TwitterProfile': 'i-lucide-twitter',
  };
  return iconMap[channelType] || 'i-lucide-inbox';
}

function getChannelLabel(channelType) {
  const labelMap = {
    'Channel::WebWidget': 'Web Widget',
    'Channel::Api': 'API',
    'Channel::Whatsapp': 'WhatsApp',
    'Channel::FacebookPage': 'Facebook',
    'Channel::Email': 'Email',
    'Channel::Telegram': 'Telegram',
    'Channel::TwitterProfile': 'Twitter',
  };
  return labelMap[channelType] || 'Canal';
}
</script>

<template>
  <div class="flex flex-col rounded-xl border border-n-weak bg-n-solid-2 p-4">
    <!-- Header -->
    <div class="mb-4">
      <h3 class="text-base font-semibold text-n-slate-12">{{ title }}</h3>
    </div>

    <!-- Loading State -->
    <div v-if="loading" class="flex items-center justify-center h-64">
      <Spinner size="large" />
    </div>

    <!-- Empty State -->
    <div
      v-else-if="data.length === 0"
      class="flex flex-col items-center justify-center h-64 text-n-slate-11"
    >
      <span class="i-lucide-inbox text-3xl mb-2" />
      <span class="text-sm">Nenhuma caixa de entrada encontrada</span>
    </div>

    <!-- List -->
    <div v-else class="space-y-3">
      <div
        v-for="inbox in data"
        :key="inbox.id"
        class="flex items-center gap-3 p-3 rounded-lg bg-n-alpha-1 hover:bg-n-alpha-2 transition-colors"
      >
        <div
          class="w-10 h-10 rounded-lg bg-n-blue-3 flex items-center justify-center"
        >
          <span
            :class="getChannelIcon(inbox.channelType)"
            class="text-lg text-n-blue-11"
          />
        </div>
        <div class="flex-1 min-w-0">
          <div class="text-sm font-medium text-n-slate-12 truncate">
            {{ inbox.name }}
          </div>
          <div class="text-xs text-n-slate-10">
            {{ getChannelLabel(inbox.channelType) }}
          </div>
        </div>
        <div class="text-right">
          <div class="text-sm font-semibold text-n-slate-12">
            {{ inbox.conversations.toLocaleString('pt-BR') }}
          </div>
          <div class="text-xs text-n-slate-10">conversas</div>
        </div>
      </div>
    </div>
  </div>
</template>
